export default {
    "common.1": "Kiat",
    "common.2": "Konfirmasi",
    "common.3": "Deposito",
    "common.4": "Penarikan",
    "common.5": "Memperhatikan",
    "common.6": "Membatalkan",
    "common.7": "Berhasil diterima",
    "common.8": "Tugas Sistem",
    "common.9": "Tanya Jawab",
    "common.10": "Catatan terperinci",
    "common.12": "Kesuksesan",
    "common.13": "Gagal",
    "common.14": "Sedang berlangsung",
    "common.20": "Menerima",
    "common.21": "Ups! Belum ada data!",
    "common.22": "Permintaan waktu habis, silakan coba lagi nanti",
    "common.23": "Selamat",
    "home.1": "Penghargaan",
    "home.2": "Bonus",
    "home.4": "Populer",
    "home.22": "Selamat kepada <span style='color: #3ACAFF;'>{userName} </span> karena telah memenangkan uang tunai <span style='color: #FFD645;'>{amount}</span>",
    "home.26": "Kasino",
    "home.27": "Dompet",
    "home.28": "Agen",
    "home.29": "Ku",
    "home.44": "Level VIP Saat Ini",
    "home.45": "SuperWin777 berkomitmen untuk memberikan pengalaman berjudi yang seru, menghibur, dan tahan lama bagi para pemain. Kami telah lulus semua pemeriksaan kepatuhan dan memiliki izin hukum untuk menjalankan semua operasi perjudian dan taruhan. Hasil akhir tidak dijamin.",
    "home.46": "Mitra",
    "home.47": "Kelainan akun, silakan periksa informasi akun",
    "bouns.1": "Isi ulang uang kembali",
    "bouns.3": "Cashback",
    "bouns.13": "Deskripsi aturan",
    "bouns.14": "1.Setelah berhasil berpartisipasi dalam acara dan menyelesaikan deposit, jumlah cashback akan secara otomatis dikeluarkan ke akun game Anda tanpa pengumpulan manual.\n2.Aktivitas cashback ini dibagi menjadi tiga tahap, dan Anda harus berpartisipasi secara berurutan. Anda dapat memulai tahap kedua setelah menyelesaikan tahap pertama.\n3.Setiap pengguna hanya dapat berpartisipasi dalam aktivitas ini satu kali. Jika sistem mendeteksi alamat IP, rekening bank, alamat email, dan informasi terkait lainnya yang sama, maka pengguna tersebut akan dianggap sebagai pengguna yang sama. Jika ditemukan perilaku curang, platform berhak untuk membatalkan semua hadiah cashback dan menutup akun terkait.\n4.Platform ini memiliki hak interpretasi akhir atas acara ini.",
    "bouns.16": "Deposito ke-1",
    "bouns.17": "Deposito ke-2",
    "bouns.18": "Deposito ke-3",
    "vip.3": "Hadiah Bulanan",
    "vip.4": "Hak Penarikan",
    "vip.8": "Tingkatkan VIP",
    "vip.11": "Selesaikan {count} deposito",
    "vip.12": "Masuk selama 30 hari berturut-turut",
    "vip.14": "Bantu 2 anggota bawahan menyelesaikan penyetoran",
    "vip.15": "Hadiah Peningkatan",
    "vip.19": "Manfaat <span style='color:#FF8D24;'>VIP{level}</span> adalah sebagai berikut",
    "vip.25": "Hak Istimewa VIP{level}",
    "vip.29": "Tingkat VIP",
    "vip.30": "Tingkatkan ke VIP{level}",
    "vip.31": "Pengembalian dana taruhan permainan",
    "vip.32": "Slot",
    "vip.33": "Permainan kartu",
    "vip.34": "Olahraga",
    "vip.35": "Penangkapan ikan",
    "vip.36": "Pertaruhan:<span style = 'color: #FFD645;'>{amount1}</span>/{amount2}",
    "vip.37": "Jadilah VIP dan nikmati manfaat eksklusif berikut ini",
    "vip.38": "Tingkatkan ke pengguna VIP1 dengan deposito  apa pun",
    "vip.39": "Mendapatkan",
    "vip.40": "Jumlah penarikan maksimum",
    "vip.41": "Anda dapat meningkatkan ke VIP jika Anda memenuhi salah satu kondisi berikut",
    "vip.42": "Tingkat VIP",
    "vip.43": "Deposito {amount} ke atas",
    "vip.46": "Mendapatkan",
    "vip.47": "Bantu 2 anggota bawahan menyelesaikan penyetoran",
    "vip.48": "Jumlah Deposito",
    "invite.1": "Undang teman untuk mendapatkan hadiah",
    "invite.2": "Bagikan ke lingkaran sosial Anda",
    "invite.3": "Bagikan tautannya dengan teman-teman Anda",
    "invite.4": "Menyalin",
    "invite.5": "Salin Sukses",
    "invite.6": "Laporan langsung saya",
    "invite.7": "{personCount} orang",
    "invite.8": "Kondisi pengguna yang valid",
    "invite.9": "Deposito kumulatif",
    "invite.10": "Bawahan",
    "invite.11": "Efektif",
    "invite.12": "Nama",
    "invite.13": "Deskripsi Acara",
    "invite.14": "1.Undang sejumlah pemain baru untuk membuka peti harta karun dan dapatkan hadiah.\n2.Pengguna yang diundang perlu menyelesaikan pendaftaran melalui tautan undangan eksklusif Anda.\n3.Pengguna yang diundang akan dianggap sebagai pengguna undangan yang sah hanya setelah menyelesaikan penyetoran sejumlah uang yang ditentukan.\n4.Platform ini memiliki hak interpretasi akhir atas acara ini.",
    "proxy.1": "Rekrutmen Agen",
    "proxy.2": "Mengundang",
    "proxy.3": "Tautan Saya",
    "proxy.4": "Pengembangan dan penghargaan bagi bawahan",
    "proxy.5": "Komisi Langsung",
    "proxy.6": "Tingkat",
    "proxy.7": "Jumlah taruhan tim",
    "proxy.8": "Proporsi",
    "proxy.9": "1.Saat bawahan Anda memasang taruhan dalam permainan, Anda akan menerima hadiah yang sesuai.\r\n2.Perusahaan berhak atas interpretasi akhir dari promosi ini.",
    "proxy.10": "Data saya",
    "proxy.11": "Total komisi",
    "proxy.12": "Total taruhan",
    "proxy.13": "Total catatan",
    "proxy.14": "Terperinci",
    "proxy.15": "Komisi saya",
    "proxy.16": "pemain langsung",
    "proxy.17": "Jumlah taruhan",
    "proxy.18": "Komisi untuk hari itu akan dikreditkan ke akun Anda setelah penyelesaian pagi hari",
    "betRefund.1": "Taruhan Cashback",
    "betRefund.2": "Taruhan",
    "betRefund.3": "Rebates",
    "betRefund.4": "Kemajuan promosi",
    "betRefund.5": "Rabate berikutnya {rate}",
    "betRefund.6": "Tabel Referensi Rabat",
    "betRefund.7": "Jumlah Taruhan",
    "betRefund.8": "Tingkat rabate",
    "betRefund.9": "1.Pengguna bisa mendapatkan hadiah cashback dengan memasang taruhan pada permainan tertentu. Jumlah cashback dihitung berdasarkan tabel referensi rabat.\n2.Hanya taruhan yang valid dan sah yang berhak mendapatkan cashback. Sistem akan secara otomatis mengecualikan taruhan yang tidak valid atau tidak normal.\n3.Platform ini memiliki hak interpretasi akhir atas acara ini.",
    "lossRefund.1": "Cashback atas kerugian",
    "lossRefund.2": "Kerugian hari ini",
    "lossRefund.3": "Nilai kerugian kemarin",
    "lossRefund.4": "Jumlah cashback",
    "lossRefund.5": "Tabel Referensi Rabat Kerugian",
    "lossRefund.6": "Kekalahan dalam permainan",
    "lossRefund.7": "Tingkat rabate",
    "lossRefund.8": "1.Kerugian bersih yang dialami pengguna selama periode aktivitas dapat menikmati subsidi cashback, dan jumlah cashback dihitung sesuai dengan tabel referensi cashback kerugian.\n2.Hanya kerugian taruhan permainan yang memenuhi syarat yang berhak mendapatkan cashback. Tidak ada pengembalian dana untuk pelanggaran atau perilaku abnormal.\n3.Jika pemain tidak menerima jumlah cashback hari ini, maka akan dianggap pemain telah menyerah.\n4.Segala bentuk kecurangan atau perilaku arbitrase yang jahat akan berakibat pada diskualifikasi.\n5.Platform ini memiliki hak interpretasi akhir atas acara ini.",
    "record.1": "Tipe",
    "record.2": "Jumlah",
    "record.3": "Menyatakan",
    "record.4": "Nomor pesanan",
    "service.1": "Layanan Pelanggan Online",
    "service.2": "Jam kerja: 08:00~24:00",
    "service.3": "Bagaimana cara menarik dana?",
    "service.4": "Penarikan dana hanya berlaku untuk anggota. Anda dapat meningkatkan ke pengguna VIP1 setelah menyelesaikan deposit. Setelah peningkatan, Anda dapat langsung menarik dana.",
    "service.5": "Apa yang harus saya lakukan jika saya tidak menerima uang setelah pengisian ulang berhasil?",
    "service.6": "1.Tunggu beberapa menit. Beberapa pembayaran mungkin tertunda.\n2.Periksa apakah pembayaran Anda berhasil, ambil tangkapan layar tanda terima pembayaran Anda, dan hubungi layanan pelanggan untuk bantuan.",
    "service.7": "Apa yang harus saya lakukan jika penarikan gagal atau tidak diterima?",
    "service.8": "1.Mohon konfirmasi dengan cermat bahwa informasi akun penarikan Anda sudah benar.\n2.Jika informasi akun Anda sudah benar dan Anda mengalami beberapa kali kegagalan penarikan, kami sarankan Anda mengganti akun dan mengajukan kembali permintaan penarikan Anda.",
    "service.9": "Apakah ada biaya penarikan?",
    "service.10": "Yakinlah bahwa Superwin777 tidak akan mengenakan biaya penarikan apa pun dan berkomitmen untuk menciptakan lingkungan permainan yang adil dan transparan bagi para pemain",
    "service.11": "Apakah ada batasan penarikan?",
    "service.12": "Batas penarikan meningkat seiring dengan level VIP. Semakin tinggi levelnya, semakin tinggi pula batas penarikannya.",
    "withdraw.1": "Akun penarikan",
    "withdraw.2": "Tambahkan akun penarikan",
    "withdraw.3": "Jumlah yang dapat ditarik",
    "withdraw.4": "Pilih jumlah penarikan",
    "withdraw.5": "Jumlah penarikan yang dipilih",
    "withdraw.11": "Saldo penarikan tunai tidak mencukupi",
    "withdraw.14": "Slip penarikan sudah dikirim ke bank, mohon perhatikan perubahan pada rekening bank",
    "withdraw.15": "Jumlah penarikan maksimum",
    "withdraw.16": "Jumlah penarikan maksimum adalah nilai sebenarnya dari akun",
    "withdraw.17": "Permintaan penarikan sedang diproses",
    "withdraw.18": "Penarikan sedang berlangsung",
    "charge.1": "Pilih jumlah setoran",
    "charge.2": "Berpartisipasi dalam kegiatan",
    "charge.3": "Bonus spesial untuk pengguna baru",
    "charge.4": "Jumlah setoran",
    "charge.5": "Jumlah cashback",
    "charge.7": "Tidak berpartisipasi dalam kegiatan",
    "charge.8": "Pilih metode pembayaran",
    "charge.9": "Pilih bank",
    "account.bind.1": "Tambahkan akun penarikan",
    "account.bind.2": "Akun penarikan",
    "account.bind.3": "Silakan pilih",
    "account.bind.4": "Akun penarikan",
    "account.bind.5": "account.bind.5    /*no value*/",
    "account.bind.6": "Nama pengguna",
    "account.bind.7": "Silakan masukkan nama pemegang akun",
    "account.bind.8": "Silakan masukkan nomor akun penarikan Anda",
    "account.bind.9": "account.bind.9    /*no value*/",
    "account.bind.10": "Kesalahan Format",
    "account.bind.11": "account.bind.11    /*no value*/",
    "account.bind.12": "account.bind.12    /*no value*/",
    "account.bind.13": "account.bind.13    /*no value*/",
    "account.bind.14": "Nomor telepon",
    "account.bind.15": "Silakan masukkan nomor ponsel Anda",
    "times.1": "times.1    /*no value*/",
    "times.2": "times.2    /*no value*/",
    "times.3": "times.3    /*no value*/",
    "times.4": "times.4    /*no value*/",
    "times.5": "times.5    /*no value*/",
    "times.6": "times.6    /*no value*/",
    "my.1": "Merekam",
    "my.2": "Bahasa",
    "my.3": "Mengajak",
    "prop.1": "Pengguna yang terhormat:\n     Jumlah penarikan Anda telah mencapai batas penarikan maksimum untuk level <span style=\"color: #FF990B;\">VIP{vipLevel}</span> Anda saat ini. Harap tingkatkan level VIP Anda untuk meningkatkan batas penarikan sebelum melakukan penarikan.",
    "prop.2": "Tingkatkan jumlah penarikan",
    "prop.4": "Selamat karena telah menerima hadiah cashback isi ulang eksklusif! Hadiah uang tunai Anda sejumlah <span style=\"color: #FF990B;\">{amount}</span> telah ditambahkan ke akun Anda. Anda dapat menarik kemenangan Anda secara langsung tanpa perlu memasang taruhan apa pun.",
    "prop.5": "Pergi untuk melihat",
    "prop.6": "Selamat atas peningkatan ke pengguna <span style=\"color: #FF990B;\">VIP{vipLevel}</span>. Hadiah peningkatan <span style='color: #FF990B;'>{amount}</span> telah dikreditkan ke akun Anda. Silakan periksa.",
    "prop.8": "Tingkatkan level VIP",
    "prop.11": "Saldo akun Anda saat ini tidak mencukupi dan kurang dari jumlah taruhan minimum",
    "prop.12": "Masuk ke dalam permainan",
    "prop.14": "Hadiah Uang Tunai",
    "prop.15": "Selamat                     \nSelamat atas kemenangan bonus sambutan\nRp30.000\nBergabunglah sekarang untuk memulai pengalaman luar biasa dan menangkan hadiah besar!",
    "prop.19": "Deposit Rp30k untuk meningkatkan ke VIP1, lalu Anda dapat menarik uang tuna",
    "prop.21": "Pengguna yang terhormat:\n   Batas penarikan VIP Anda saat ini adalah {amount}. Silakan pilih {amount} untuk penarikan, atau tingkatkan ke VIP2 untuk batas penarikan yang lebih tinggi.",
    "prop.22": "Pilih {amount}",
    "prop.35": "<div style='color: #FFB947; font-size: 16rem; font-weight: bold;'>Saldo Anda sekarang tersedia untuk ditarik!</div> Deposit <span style='color: #FFB947;'>Rp30k</span> untuk meningkatkan ke <span style='color: #FFB947;'>VIP1</span>  dan mendapatkan kualifikasi penarikan.",
    "prop.36": "Saldo yang dapat ditarik",
    "prop.37": "Deposit Sekarang",
    "prop.38": "Deposit <span style='color: #FFB947;'>Rp300k </span> untuk upgrade ke <span style='color: #FFB947;'>VIP2</span>!\nBatas penarikan maksimum untuk <span style='color: #FFB947;'>VIP2</span> adalah <span style='color: #FFB947;'>Rp1.000k</span>.\nSetelah Anda menjadi VIP2, Anda dapat langsung menarik seluruh jumlah penarikan Anda.",
    "prop.39": "Bergabunglah dengan acara ini sekarang dan nikmati cashback 100%!\r\nBonus dapat ditarik langsung!",
    "prop.40": "Rincian",
    "prop.41": "Deposit Sekarang",
    "prop.42": "Level VIP saat ini tidak mencukupi. Anda dapat memilih untuk memainkan game lain atau meningkatkan level VIP Anda.",
    "prop.43": "Mainkan game lainnya",
    "prop.44": "Anggota VIP1 yang terhormat, batas penarikan Rp10k Anda telah dibuka, segera tarik uang Anda!",
    "prop.45": "prop.45    /*no value*/",
    "prop.46": "prop.46    /*no value*/",
    "prop.47": "prop.47    /*no value*/",
    "prop.48": "prop.48    /*no value*/",
    "prop.49": "prop.49    /*no value*/",
    "prop.50": "prop.50    /*no value*/",
    "prop.51": "prop.51    /*no value*/",
    "orderview.1": "orderview.1    /*no value*/",
    "orderview.2": "orderview.2    /*no value*/",
    "orderview.3": "orderview.3    /*no value*/",
    "orderview.4": "orderview.4    /*no value*/",
    "orderview.5": "orderview.5    /*no value*/",
    "orderview.6": "orderview.6    /*no value*/",
    "orderview.7": "orderview.7    /*no value*/",
    "orderview.8": "orderview.8    /*no value*/",
    "orderview.9": "orderview.9    /*no value*/",
    "orderview.10": "orderview.10    /*no value*/",
    "orderview.11": "orderview.11    /*no value*/",
    "orderview.12": "orderview.12    /*no value*/",
    "orderview.13": "orderview.13    /*no value*/",
    "orderview.14": "orderview.14    /*no value*/",
    "orderview.15": "orderview.15    /*no value*/",
    "orderview.16": "orderview.16    /*no value*/",
    "orderview.17": "orderview.17    /*no value*/",
    "orderview.18": "orderview.18    /*no value*/",
    "orderview.19": "orderview.19    /*no value*/",
    "orderview.20": "orderview.20    /*no value*/",
    "orderview.21": "orderview.21    /*no value*/",
    "orderview.22": "orderview.22    /*no value*/",
    "orderview.23": "orderview.23    /*no value*/",
    "orderview.24": "orderview.24    /*no value*/",
    "orderview.25": "orderview.25    /*no value*/",
    "orderview.26": "orderview.26    /*no value*/",
    "orderview.27": "orderview.27    /*no value*/",
    "orderview.28": "orderview.28    /*no value*/",
    "orderview.29": "orderview.29    /*no value*/",
    "orderview.30": "orderview.30    /*no value*/",
    "orderview.31": "orderview.31    /*no value*/",
    "orderview.32": "orderview.32    /*no value*/",
    "orderview.33": "orderview.33    /*no value*/",
    "orderview.34": "orderview.34    /*no value*/",
    "orderview.35": "orderview.35    /*no value*/",
    "orderview.36": "orderview.36    /*no value*/",
    "orderview.37": "orderview.37    /*no value*/",
    "orderview.38": "orderview.38    /*no value*/",
    "orderview.39": "orderview.39    /*no value*/",
    "orderview.40": "orderview.40    /*no value*/",
    "home.img.1": "gold_icon_id.png",
    "home.img.6": "home_icon_vip_id.png",
    "home.img.7": "home_icon_share_id.png",
    "banner.img.1": "banner_1_id.png",
    "banner.img.2": "banner_2_id.png",
    "banner.img.3": "banner_3_id.png",
    "banner.img.4": "banner_4_id.png",
    "banner.img.5": "banner_5_id.png",
    "banner.img.6": "banner_6_id.png",
    "banner.img.7": "banner_7_id.png",
    "activitys.img.1": "cash_des_id.png",
    "activitys.img.4": "newUser_bg_id.png",
    "activitys.img.6": "cash_amount_id.png",
    "activitys.img.8": "cash_item_complete_id.png",
    "activitys.img.9": "cash_max_id.png",
    "activitys.img.11": "cash_tip_2_id.png",
    "activitys.img.12": "cash_tip_3_id.png",
    "customer.img.1": "customerImg_id.png"
}